import React from 'react';

const WorkQueueItem = ({
  icon,
  eyebrow,
  title,
  meta = [],
  status,
  actions,
  accent = 'primary',
}) => (
  <article className={`work-queue-item work-queue-${accent}`}>
    <div className="work-queue-marker" aria-hidden="true">
      {icon}
    </div>

    <div className="work-queue-body">
      {eyebrow && <span className="work-queue-eyebrow">{eyebrow}</span>}
      <h3>{title}</h3>

      {meta.length > 0 && (
        <dl className="work-queue-meta">
          {meta.filter(Boolean).map((item, index) => (
            <div key={`${item.label}-${index}`}>
              <dt>{item.label}</dt>
              <dd>{item.value}</dd>
            </div>
          ))}
        </dl>
      )}
    </div>

    {(status || actions) && (
      <aside className="work-queue-side">
        {status && <div className="work-queue-status">{status}</div>}
        {actions && <div className="work-queue-actions">{actions}</div>}
      </aside>
    )}
  </article>
);

export default WorkQueueItem;
